<template>
    <a v-if="!button" :href="link" target="_blank">{{ short || link }}</a>
    <div v-else>
        <a :href="link" style="text-decoration: none" target="_blank"
            ><v-icon x-small>mdi-open-in-new</v-icon></a
        >&nbsp;<span>{{ short || link }}</span>
    </div>
</template>

<script>
export default {
    name: 'QiUrlFormatter',
    props: {
        url: {
            type: String,
            required: true
        },
        button: {
            type: Boolean,
            required: false,
            defaultValue: () => false
        }
    },
    data() {
        return {
            link: '',
            short: ''
        }
    },
    watch: {
        url: {
            handler() {
                const values = this.url ? this.url.split('|') : ''
                if (values.length === 2) {
                    this.short = values[0]
                    this.link = values[1]
                } else {
                    this.short = ''
                    this.link = values[0]
                }
            },
            immediate: true
        }
    }
}
</script>
